import { BuildInfoComponent } from './build-info/build-info.component';
import { VersionComponent } from './version/version.component';

// WARNING!!! Containers for app-common-services.module.ts
// DO NOT EXPORT, DO NOT INCLUDE IN containers:
// OverlayComponent
// ToastViewComponent

export const containers = [VersionComponent, BuildInfoComponent];

export * from './build-info/build-info.component';
export * from './version/version.component';
